module.exports = __webpack_public_path__ + "static/media/icon-camera.8360c8be.png";